export const isError = (e: unknown): e is Error => e instanceof Error;
